import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import "./styles.css";
import { queryClient } from "./lib/query-client";
import { router } from "./router";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("#root is missing from index.html");

createRoot(rootElement).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
			<Toaster
				position="bottom-right"
				toastOptions={{
					duration: 3500,
					style: {
						fontSize: "0.875rem",
						color: "var(--color-ink-100)",
						background: "var(--color-ink-800)",
						border: "1px solid var(--color-ink-600)",
					},
					success: { iconTheme: { primary: "var(--color-ok)", secondary: "var(--color-ink-950)" } },
					error: { iconTheme: { primary: "var(--color-bad)", secondary: "var(--color-ink-950)" } },
				}}
			/>
		</QueryClientProvider>
	</StrictMode>,
);
